import { useState } from 'react'
import { Button, Tooltip } from 'antd'
import SofiaChat from 'components/Sofia/SofiaChat'

// Abre a Sofia. Dentro de um processo vira um botão normal (já com o processo
// escolhido); sem processo, é o botão flutuante do canto da tela.
const Chat = ({ process }) => {
  const [aberto, setAberto] = useState(false)
  const gatilho = process ? (
    <Button onClick={() => setAberto(true)}>✨ Perguntar à Sofia</Button>
  ) : (
    <Tooltip title="Sofia · assistente jurídica" placement="left">
      <button
        type="button"
        aria-label="Falar com a Sofia (assistente jurídica)"
        onClick={() => setAberto(true)}
        className="sofia-flutuante"
        style={{
          position: 'fixed', zIndex: 1000, borderRadius: 18, border: 'none',
          cursor: 'pointer', fontSize: 26, color: '#fff', display: 'grid', placeItems: 'center',
          background: 'linear-gradient(135deg, #13143a 0%, #2563eb 70%, #7c3aed 100%)',
          boxShadow: '0 10px 25px rgba(37, 99, 235, .35)',
        }}
      >
        ✨
      </button>
    </Tooltip>
  )
  return (
    <>
      {gatilho}
      <SofiaChat open={aberto} onClose={() => setAberto(false)} processoInicial={process ? { id: process.id, NProcesso: process.NProcesso } : null} />
    </>
  )
}

export default Chat
